import BannerApp from "./components/banner-carrossel/BannerCarrosselApp"
import HtmlApp from "@/components/HtmlApp"
import VitrineApp from "@/components/vitrine/VitrineApp"
import MidiaApp from "@/components/midia/MidiaApp"
import WidgetNewsletterApp from "@/components/widget-especifico/modelos/default/newsletter/WidgetNewsletterApp"
import WidgetNewsletter02App from "./components/widget-especifico/modelos/default/newsletter02/WidgetNewsletter02App"
import WidgetAgroApp from "./components/widget-especifico/modelos/agromania/WidgetAgroApp"
import WidgetCasaFerrariApp from "./components/widget-especifico/modelos/casa-ferrari/WidgetCasaFerrariApp"
import WidgetDenimZeroApp from "./components/widget-especifico/modelos/denim-zero/newsletter/WidgetDenimZeroApp"
import BlogDenimZeroApp from "./components/widget-especifico/modelos/denim-zero/blog/BlogDenimZeroApp"
import WidgetModaLoveApp from "./components/widget-especifico/modelos/moda-love/WidgetModaLoveApp"
import WidgetPrincipessaApp from "./components/widget-especifico/modelos/principessa/newsletter/WidgetPrincipessaApp"
import InfoClientePrincipessaApp from "./components/widget-especifico/modelos/principessa/info-cliente/InfoClientePrincipessaApp"
import WidgetViaEvangelicaApp from "./components/widget-especifico/modelos/via-evangelica/newsletter/WidgetViaEvangelicaApp"
import BlogViaEvangelicaApp from "./components/widget-especifico/modelos/via-evangelica/blog/BlogViaEvangelicaApp"
import WidgetTexCottonApp from "./components/widget-especifico/modelos/texcotton/WidgetTexCottonApp"
import BannerFixoApp from "@/components/banner-fixo/BannerFixoApp"
import TitleApp from "@/components/title/TitleApp"
import MenuApp from "@/components/menu/MenuApp.tsx"
import AvaliacaoApp from "./components/widget-plugin/avaliacao/AvaliacaoApp"
import InstagramApp from "./components/widget-plugin/instagram/InstagramApp"
import BlogPluginApp from "./components/widget-plugin/blog/BlogPluginApp"
import type { BannerCarrosselAppProps } from "./components/banner-carrossel/banner-carrossel.props"
import type { VitrineAppProps } from "@/components/vitrine/types/vitrineApp.props"
import type { MidiaAppProps } from "@/components/midia/midia.props.ts"
import type { WidgetAppProps } from "@/components/widget-especifico/types/widget.props"
import type { BlogAppProps } from "./components/widget-especifico/types/blog.props"
import type { BannerFixoAppProps } from "@/components/banner-fixo/banner-fixo.props"
import type { TitleAppProps } from "@/components/title/title.props"
import type { MenuAppProps } from "@/components/menu/menu.props.ts"
import type { InfoClienteAppProps } from "./components/widget-especifico/modelos/principessa/info-cliente/info-cliente.props"
import type { AvaliacaoAppProps } from "./components/widget-plugin/avaliacao/avaliacao-app.props"
import type { InstagramAppProps } from "./components/widget-plugin/instagram/instagram-app.props"
import type { BlogPluginAppProps } from "./components/widget-plugin/blog/blog-app.props"

export default class Components {
    bannerCarrossel(props: BannerCarrosselAppProps) {
        return new BannerApp(props)
    }

    html(props: { id: string; html: string }) {
        return new HtmlApp(props)
    }

    vitrine(props: VitrineAppProps) {
        return new VitrineApp(props)
    }

    midia(props: MidiaAppProps) {
        return new MidiaApp(props)
    }

    widgetNewsletter(props: WidgetAppProps) {
        return new WidgetNewsletterApp(props)
    }

    widgetNewsletter02(props: WidgetAppProps) {
        return new WidgetNewsletter02App(props)
    }

    widgetAgro(props: WidgetAppProps) {
        return new WidgetAgroApp(props)
    }

    widgetCasaFerrari(props: WidgetAppProps) {
        return new WidgetCasaFerrariApp(props)
    }

    widgetDenimZero(props: WidgetAppProps) {
        return new WidgetDenimZeroApp(props)
    }

    blogDenimZero(props: BlogAppProps) {
        return new BlogDenimZeroApp(props)
    }

    widgetModaLove(props: WidgetAppProps) {
        return new WidgetModaLoveApp(props)
    }

    widgetPrincipessa(props: WidgetAppProps) {
        return new WidgetPrincipessaApp(props)
    }

    infoClientePrincipessa(props: InfoClienteAppProps) {
        return new InfoClientePrincipessaApp(props)
    }

    widgetViaEvangelica(props: WidgetAppProps) {
        return new WidgetViaEvangelicaApp(props)
    }

    blogViaEvangelica(props: BlogAppProps) {
        return new BlogViaEvangelicaApp(props)
    }

    widgetTexCotton(props: WidgetAppProps) {
        return new WidgetTexCottonApp(props)
    }

    bannerFixo(props: BannerFixoAppProps) {
        return new BannerFixoApp(props)
    }

    title(props: TitleAppProps) {
        return new TitleApp(props)
    }

    menu(props: MenuAppProps) {
        return new MenuApp(props)
    }

    widgetPluginAvaliacao(props: AvaliacaoAppProps) {
        return new AvaliacaoApp(props)
    }

    widgetPluginInstagram(props: InstagramAppProps) {
        return new InstagramApp(props)
    }

    widgetPluginBlog(props: BlogPluginAppProps) {
        return new BlogPluginApp(props)
    }
}
